const SITE_URL = 'https://terumo.kliffhost.in/';
const API = 'https://kliffhost.in/terumo';
const API_URL = 'https://kliffhost.in/terumo/api';
const X_API_KEY = "1234"
export {SITE_URL,API_URL,API,X_API_KEY};